/* JT Pro PDP — interactions from clean-code handoff */
(function () {
  "use strict";
  if (window.JTProPDP) return;
  window.JTProPDP = true;

  const scope = document;

  /* Offer bar: hidden over the hero (theme header shows). After the hero,
     desktop swaps Cosmo for this bar; mobile keeps Cosmo and shows bottom ATC. */
  const bar = document.getElementById("obar");
  const hero = document.querySelector(".jt-pro .hero") || document.getElementById("top");

  /* Escape height:0 section containing-blocks so fixed bottom ATC works on mobile. */
  if (bar && !bar.closest(".jt-pro-obar-portal")) {
    const portal = document.createElement("div");
    portal.className = "jt-pro jt-pro-obar-portal";
    portal.appendChild(bar);
    document.body.appendChild(portal);
  }

  /* Match Cosmo nav height (used by sticky offsets). */
  const cosmoNav = document.getElementById("cosmo-nav");
  const cosmoHeader =
    (cosmoNav && cosmoNav.querySelector(".site-header")) ||
    document.querySelector("#cosmo-nav .site-header");
  const mqDesktop = window.matchMedia("(min-width: 961px)");
  const measureNav = () => {
    const h =
      (cosmoHeader && cosmoHeader.offsetHeight) ||
      (cosmoNav && cosmoNav.offsetHeight) ||
      70;
    document.documentElement.style.setProperty("--jt-pro-nav-h", h + "px");
  };
  measureNav();
  addEventListener("resize", measureNav);

  /* Keep Cosmo nav solid (white + dark ink) — never transparent on this page. */
  if (cosmoHeader) {
    cosmoHeader.dataset.transparent = "false";
    cosmoHeader.dataset.state = "scrolled";
  }

  function syncStickyNav() {
    const scrolled = window.scrollY > 8;
    let show = scrolled;
    if (mqDesktop.matches) {
      /* Desktop: swap Cosmo for offer bar after the hero. */
      if (!hero) return;
      show = hero.getBoundingClientRect().bottom <= 12;
    }
    document.body.classList.toggle("jt-pro-obar-on", show);
    if (bar) {
      bar.classList.toggle("stuck", show);
      bar.classList.toggle("obar-mobile-bottom", !mqDesktop.matches);
    }
    if (cosmoHeader) cosmoHeader.dataset.state = "scrolled";
  }

  syncStickyNav();
  addEventListener("scroll", syncStickyNav, { passive: true });
  addEventListener("resize", syncStickyNav);

  /* Theme #body { overflow-x: hidden } creates a scrollport that kills sticky.
     Walk ancestors of the Tech Specs 3D column and force overflow visible. */
  (function unlockSpecSticky() {
    const col = document.querySelector(".jt-pro .spec-3d");
    if (!col) return;
    let n = col.parentElement;
    while (n && n !== document.documentElement) {
      n.style.setProperty("overflow", "visible", "important");
      n.style.setProperty("overflow-x", "visible", "important");
      n.style.setProperty("overflow-y", "visible", "important");
      n = n.parentElement;
    }
  })();

  const navLinks = [...document.querySelectorAll(".obar-nav a")];
  if (navLinks.length) {
    const secIO = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (e.isIntersecting) {
            navLinks.forEach((a) =>
              a.classList.toggle("on", a.getAttribute("href") === "#" + e.target.id)
            );
          }
        }),
      { rootMargin: "-45% 0px -50% 0px" }
    );
    navLinks.forEach((a) => {
      const s = document.querySelector(a.getAttribute("href"));
      if (s) secIO.observe(s);
    });
  }

  /* Reveal */
  const io = new IntersectionObserver(
    (es) =>
      es.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      }),
    { rootMargin: "0px 0px -8% 0px", threshold: 0.05 }
  );
  scope.querySelectorAll(".reveal").forEach((el) => io.observe(el));

  /* Tabs */
  scope.querySelectorAll("[data-tabs]").forEach((group) => {
    const panes = document.querySelector('[data-panes="' + group.dataset.tabs + '"]');
    if (!panes) return;
    group.querySelectorAll(".tab").forEach((tab) =>
      tab.addEventListener("click", () => {
        const i = +tab.dataset.i;
        group.querySelectorAll(".tab").forEach((t) => t.classList.toggle("on", t === tab));
        panes.querySelectorAll(".tile, .pane-copy").forEach((box) =>
          [...box.querySelectorAll(":scope > .pane")].forEach((p, j) =>
            p.classList.toggle("on", j === i)
          )
        );
      })
    );
  });

  /* Accordions (FAQ + kit) */
  const toggle = (wrap, panel, open) => {
    if (!panel) return;
    const inner = panel.firstElementChild;
    if (!inner) return;
    if (open) {
      panel.style.height = inner.scrollHeight + "px";
      panel.addEventListener(
        "transitionend",
        () => {
          if (wrap.classList.contains("open")) panel.style.height = "auto";
        },
        { once: true }
      );
    } else {
      panel.style.height = inner.scrollHeight + "px";
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          panel.style.height = "0px";
        })
      );
    }
  };
  scope.querySelectorAll(".q > button").forEach((b) =>
    b.addEventListener("click", () => {
      const q = b.parentElement;
      const open = q.classList.toggle("open");
      b.setAttribute("aria-expanded", open);
      toggle(q, q.querySelector(".a"), open);
    })
  );
  scope.querySelectorAll(".acc-q").forEach((b) =>
    b.addEventListener("click", () => {
      const it = b.parentElement;
      const open = it.classList.toggle("open");
      b.setAttribute("aria-expanded", open);
      toggle(it, it.querySelector(".acc-a"), open);
    })
  );
  scope.querySelectorAll("[data-open]").forEach((a) =>
    a.addEventListener("click", () => {
      const it = document.getElementById(a.dataset.open);
      if (it && !it.classList.contains("open")) {
        const btn = it.querySelector(".acc-q");
        if (btn) btn.click();
      }
    })
  );

  /* Kit gallery */
  const thumbs = [...scope.querySelectorAll(".kg-thumb")];
  const main = document.getElementById("kitMain");
  const photo = document.getElementById("kitPhoto");
  const strip = scope.querySelector(".kg-strip");
  if (thumbs.length && main && photo) {
    let cur = 0;
    const scrollThumbIntoView = (t) => {
      if (!strip || !t) return;
      /* Center the selected thumb in the horizontal strip (mobile carousel). */
      const left = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
      strip.scrollTo({
        left: Math.max(0, Math.min(left, strip.scrollWidth - strip.clientWidth)),
        behavior: "smooth",
      });
    };
    const show = (i) => {
      cur = (i + thumbs.length) % thumbs.length;
      const t = thumbs[cur];
      thumbs.forEach((x) => x.classList.toggle("on", x === t));
      scrollThumbIntoView(t);
      photo.classList.add("swap");
      setTimeout(() => {
        main.src = t.dataset.full;
        main.alt = t.dataset.alt || "";
        main.classList.toggle("cover", !!t.dataset.cover);
        photo.classList.remove("swap");
      }, 180);
    };
    thumbs.forEach((t, i) => t.addEventListener("click", () => show(i)));
    const prev = scope.querySelector(".kg-nav.prev");
    const next = scope.querySelector(".kg-nav.next");
    if (prev) prev.addEventListener("click", () => show(cur - 1));
    if (next) next.addEventListener("click", () => show(cur + 1));
  }

  /* Video modal */
  const modal = document.getElementById("modal");
  const mv = document.getElementById("modalVideo");
  if (modal && mv) {
    const box = modal.querySelector(".box");
    const closeModal = () => {
      modal.classList.remove("open");
      mv.pause();
      mv.removeAttribute("src");
      mv.load();
      document.body.style.overflow = "";
    };
    mv.addEventListener("loadedmetadata", () => {
      if (box) box.classList.toggle("portrait", mv.videoHeight > mv.videoWidth);
    });
    scope.querySelectorAll("[data-video]").forEach((b) =>
      b.addEventListener("click", () => {
        if (box) box.classList.remove("portrait");
        mv.src = b.dataset.video;
        modal.classList.add("open");
        document.body.style.overflow = "hidden";
        mv.play().catch(() => {});
      })
    );
    const closeBtn = document.getElementById("modalClose");
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    modal.addEventListener("click", (e) => {
      if (e.target === modal) closeModal();
    });
    addEventListener("keydown", (e) => {
      if (e.key === "Escape") closeModal();
    });
  }

  /* Tech Specs 3D viewer — same load path as the configurator */
  const spec3d = document.getElementById("spec3d");
  const specName = document.getElementById("specColorName");
  const specFit = document.getElementById("specFit");
  if (!spec3d) return;

  const dataEl = document.getElementById("jt-pro");
  const facesBase = (dataEl && dataEl.dataset.facesBase) || "";
  const bandAoUrl = (dataEl && dataEl.dataset.bandAo) || "";
  const glbUrl = (dataEl && dataEl.dataset.glb) || "";
  const hdrUrl = (dataEl && dataEl.dataset.hdr) || "";
  const stage = spec3d.closest(".spec-stage");

  const MV_SRC = "https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js";
  const ensureModelViewer = () => {
    if (customElements.get("model-viewer")) return Promise.resolve();
    if (!document.querySelector('script[data-jt-pro-mv], script[src*="model-viewer"]')) {
      const s = document.createElement("script");
      s.type = "module";
      s.src = MV_SRC;
      s.dataset.jtProMv = "1";
      document.head.appendChild(s);
    }
    return customElements.whenDefined("model-viewer");
  };

  const startModel = () => {
    if (spec3d.getAttribute("src")) return;
    if (!glbUrl) {
      console.warn("JrTrack Pro 3D viewer: missing GLB URL");
      return;
    }
    if (hdrUrl) spec3d.setAttribute("environment-image", hdrUrl);
    /* Force a layout pass so model-viewer measures a real canvas size. */
    if (stage) void stage.offsetWidth;
    spec3d.setAttribute("src", glbUrl);
  };

  ensureModelViewer()
    .then(() => {
      /* Load when the specs block is near the viewport (or immediately if already in view). */
      const root = spec3d.closest(".spec-layout") || spec3d;
      const io3d = new IntersectionObserver(
        (entries) => {
          if (entries.some((e) => e.isIntersecting)) {
            startModel();
            io3d.disconnect();
          }
        },
        { rootMargin: "200px 0px", threshold: 0.01 }
      );
      io3d.observe(root);
      /* Fallback if IO never fires (some preview iframes). */
      setTimeout(startModel, 2500);
    })
    .catch(() => {
      console.warn("JrTrack Pro 3D viewer: model-viewer script did not load");
    });

  const BANDS = {
    b: { name: "Black", fit: "Active-Fit", hex: "#1A1A1A", face: "orange" },
    bl: { name: "Blue", fit: "Active-Fit", hex: "#2E81D8", face: "blue" },
    g: { name: "Green", fit: "Active-Fit", hex: "#3F8A61", face: "green" },
    p: { name: "Pink", fit: "Active-Fit", hex: "#F7A6DA", face: "pink" },
    t: { name: "Teal", fit: "Active-Fit", hex: "#6AD5DE", face: "teal" },
  };
  let band = "b";
  let faceToken = 0;
  let faceShown = null;

  const paintBand = async () => {
    const c = BANDS[band];
    if (!c.hex || !spec3d.model) return;
    const m = spec3d.model.materials.find((x) => x.name === "band-silicone");
    if (m) m.pbrMetallicRoughness.setBaseColorFactor(c.hex);
    const disp = spec3d.model.materials.find((x) => x.name === "display_on");
    if (!disp || !disp.emissiveTexture || faceShown === c.face) return;
    const tok = ++faceToken;
    try {
      const tex = await spec3d.createTexture(facesBase + c.face + ".webp");
      if (tok !== faceToken) return;
      disp.emissiveTexture.setTexture(tex);
      faceShown = c.face;
    } catch (e) {
      /* keep the current face */
    }
  };

  const applyFinish = async () => {
    if (!spec3d.model) return;
    const mats = spec3d.model.materials;
    const get = (n) => mats.find((m) => m.name === n);
    const bandMat = get("band-silicone");
    if (bandMat) bandMat.pbrMetallicRoughness.setRoughnessFactor(0.5);
    for (const [n, c] of Object.entries({
      body: [0.138, 0.15, 0.17, 1],
      bezel: [0.088, 0.096, 0.112, 1],
    })) {
      const m = get(n);
      if (m) m.pbrMetallicRoughness.setBaseColorFactor(c);
    }
    if (!bandAoUrl) return;
    try {
      const ao = new Uint8Array(await (await fetch(bandAoUrl)).arrayBuffer());
      const sym = Object.getOwnPropertySymbols(spec3d).find((x) => x.description === "scene");
      if (!sym) return;
      const meshes = [];
      spec3d[sym].traverse((o) => {
        if (o.isMesh && o.material && o.material.name === "band-silicone") meshes.push(o);
      });
      meshes.sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
      if (
        !meshes.length ||
        meshes.reduce((n, o) => n + o.geometry.attributes.position.count, 0) !== ao.length
      )
        return;
      let off = 0;
      for (const o of meshes) {
        const n = o.geometry.attributes.position.count;
        const col = new Float32Array(n * 3);
        for (let i = 0; i < n; i++) col[i * 3] = col[i * 3 + 1] = col[i * 3 + 2] = ao[off + i] / 255;
        off += n;
        o.geometry.setAttribute("color", new o.geometry.attributes.position.constructor(col, 3));
        o.material.vertexColors = true;
        o.material.needsUpdate = true;
      }
    } catch (e) {
      /* no AO; band still renders */
    }
  };

  const onLoaded = () => {
    paintBand();
    applyFinish();
  };
  spec3d.addEventListener("load", onLoaded);
  if (spec3d.loaded) onLoaded();

  scope.querySelectorAll(".spec-3d .sw").forEach((b) =>
    b.addEventListener("click", () => {
      band = b.dataset.color;
      const c = BANDS[band];
      if (specName) specName.textContent = c.name;
      if (specFit) specFit.textContent = c.fit;
      paintBand();
      scope.querySelectorAll(".spec-3d .sw").forEach((x) => x.classList.toggle("on", x === b));
    })
  );
})();
